import Link from 'next/link'
import classes from './styles.module.css'
import Image, {StaticImageData} from 'next/image'
import Button from 'components/button/Button'
import GradientText from 'components/gradient-text/GradientText'

interface TwoPartsInfoBoxesSectionProps {
  data: {
    id: string
    topTitle: string
    title: string
    desc: string
    subHeading?: string
    imageSrc: StaticImageData
    btmText?: string
    infoBoxes?: {
      title: string
      description?: string
      icon: StaticImageData
    }[]
    primaryCta?: {
      text: string
      url: string
      icon?: StaticImageData
      bgColor?: string
      fontColor?: string
    }
  }
  sectionBgColor?: string
  primaryFontColor?: string
  secondaryFontColor?: string
  mainFlexDirection?: 'row' | 'row-reverse'
  showSeparator?: boolean
  infoBoxIconSize?: number
  customInfoBoxesContainerStyles?: React.CSSProperties
  customInfoBoxTitleStyles?: React.CSSProperties
  customInfoBoxDescriptionStyles?: React.CSSProperties
  customInfoBoxStyles?: React.CSSProperties
  customSectionStyles?: React.CSSProperties
}

const TwoPartsInfoBoxesSection = ({
  data,
  sectionBgColor,
  primaryFontColor,
  secondaryFontColor,
  mainFlexDirection,
  showSeparator = true,
  infoBoxIconSize,
  customInfoBoxesContainerStyles,
  customInfoBoxTitleStyles,
  customInfoBoxDescriptionStyles,
  customInfoBoxStyles,
  customSectionStyles,
}: TwoPartsInfoBoxesSectionProps) => (
  <section
    className={classes.twoPartsInfoBoxesSection}
    style={{background: sectionBgColor, ...customSectionStyles}}
    id={data?.id}
  >
    <div className={classes.container}>
      <div className={classes.main} style={{flexDirection: mainFlexDirection}}>
        <div className={classes.left}>
          <div className={classes.imageContainer}>
            <Image
              src={data.imageSrc}
              alt=""
              className={classes.image}
              width={'669'}
              height={'716'}
            />
          </div>
        </div>
        <div className={classes.right}>
          <GradientText text={data.topTitle} type="secondary" />
          {/* <h1 className={classes.topTitle}>{data.topTitle}</h1> */}
          <h2
            className={classes.title}
            style={{color: primaryFontColor}}
            dangerouslySetInnerHTML={{__html: data.title}}
          >
            {/* {data.title} */}
          </h2>
          <p className={classes.heading} style={{color: secondaryFontColor}}>
            {data.desc}
          </p>
          {data.subHeading && (
            <p className={classes.subHeading} style={{color: secondaryFontColor}}>
              {data.subHeading}
            </p>
          )}
          <div className={classes.imageContainerMobile}>
            <Image
              src={data.imageSrc}
              alt={data.title}
              className={classes.image}
              width={600}
              height={600}
            />
          </div>
          {showSeparator && (
            <div className={classes.separator} style={{color: secondaryFontColor}}></div>
          )}
          {data.btmText && (
            <p className={classes.btmText} style={{color: secondaryFontColor}}>
              {data.btmText}
            </p>
          )}
          <div className={classes.infoBoxesContainer} style={customInfoBoxesContainerStyles}>
            {data?.infoBoxes?.map((infoBox, idx) => (
              <div key={idx} className={classes.infoBox} style={customInfoBoxStyles}>
                <Image
                  className={classes.listIcon}
                  src={infoBox.icon}
                  alt={infoBox.title}
                  width={(infoBoxIconSize as unknown as number) ?? 28}
                  height={(infoBoxIconSize as unknown as number) ?? 28}
                />
                <div>
                  <h3
                    className={classes.infoBoxTitle}
                    style={{color: primaryFontColor, ...customInfoBoxTitleStyles}}
                  >
                    {infoBox.title}
                  </h3>
                  {infoBox.description && (
                    <p
                      className={classes.infoBoxDescription}
                      style={{color: secondaryFontColor, ...customInfoBoxDescriptionStyles}}
                    >
                      {infoBox.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
          {data.primaryCta && (
            <div className={classes.btnSection}>
              <Link href={data.primaryCta.url ?? ''} target="_blank">
                <Button text={data.primaryCta.text} />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  </section>
)

export default TwoPartsInfoBoxesSection
